

/**
 * 
 * @param {object} props 
 * @param {string} props.label
 * @param {object | undefined} props.labelProps
 * @param {string} props.className
 */
export default function LabeledContainer(props) {

   let className = [];

   if (props.className)
      className.push(props.className);

   className.push("relative bg-inherit border border-gray-300 p-2");

   return <div className={className.join(' ')}>
      <div className="absolute top-0 left-4 bg-white px-2 py-1 text-xs text-gray-600 translate-y-[-50%]" {...props.labelProps}>
         {props.label}
      </div>
      {props.children}
   </div>
}